if (typeof document === "undefined") return;
var createStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject, fetchPriority
) {
	var linkTag = document.createElement("link");

linkTag.rel = "stylesheet";

linkTag.type = "text/css";

if (__webpack_require__.nc) {
  linkTag.nonce = __webpack_require__.nc;
}
linkTag.href = fullhref;



	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	if (oldTag) {
            oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
          } else {
            document.head.appendChild(linkTag);
          }
	return linkTag;
}
var findStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (dataHref) {
			dataHref = dataHref.split('?')[0]
		}
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var loadStylesheet = function (chunkId, fetchPriority) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject, fetchPriority);
	})
}

// object to store loaded CSS chunks
var installedCssChunks = {
	"index": 0,

};

__webpack_require__.f.miniCss = function (chunkId, promises, fetchPriority) {
	var cssChunks = {
"src_AdminPanel_admin-routes_tsx": 1,
"src_AdminPanel_pages_Audit_Audit_tsx": 1,
"src_AdminPanel_pages_Banner_Banner_tsx": 1,
"src_AdminPanel_pages_Banners_Banners_tsx": 1,
"src_AdminPanel_pages_Dashboard_Dashboard_tsx": 1,
"src_AdminPanel_pages_Docs_Docs_tsx": 1,
"src_AdminPanel_pages_LegalDocument_LegalDocument_tsx": 1,
"src_AdminPanel_pages_Localization_Localization_tsx-src_AdminPanel_shared_entities_localized-t-51cd3a": 1,
"src_AdminPanel_pages_Modules_Modules_tsx-src_AdminPanel_shared_entities_localized-text-fields-e1723d": 1,
"src_AdminPanel_pages_Settings_Settings_tsx-src_AdminPanel_shared_entities_localized-text-fiel-896bf3": 1,
"src_AdminPanel_pages_Template_Template_tsx": 1,
"src_pages_Auth_ResetPassword_ResetPassword_tsx-src_shared_entities_password-otp-entry_passwor-aaa060": 1,
"src_pages_ChangePassword_ChangePassword_tsx-src_shared_entities_password-otp-entry_password-o-7d3ff3": 1,
"src_pages_DeleteAccountInstructions_DeleteAccountInstructions_tsx": 1,
"src_pages_FAQ_FAQ_tsx": 1,
"src_pages_Home_Home_tsx": 1,
"src_pages_Landing_Landing_tsx": 1,
"src_pages_Notifications_Notifications_tsx": 1,
"src_pages_PreApproval_Apply_Apply_tsx-src_pages_PreApproval_ui_about-card_about-card_scss-src-ffd00b": 1,
"src_pages_PreApproval_Calculator_Calculator_tsx-src_pages_PreApproval_ui_about-card_about-car-99f2b1": 1,
"src_pages_PreApproval_CarDetail_CarDetail_tsx-src_pages_PreApproval_ui_about-card_about-card_-e2fd93": 1,
"src_pages_PreApproval_Cars_Cars_tsx-src_pages_PreApproval_ui_about-card_about-card_scss-src_p-145e10": 1,
"src_pages_PreApproval_PreApproval_tsx-src_pages_PreApproval_ui_about-card_about-card_scss-src-4f9b13": 1,
"src_pages_PrivacyPolicy_PrivacyPolicy_tsx": 1,
"src_pages_Profile_Profile_tsx": 1,
"src_pages_Services_Services_tsx": 1,
"src_pages_SupportChat_SupportChat_tsx": 1,
"src_pages_SupportContact_SupportContact_tsx": 1,
"src_pages_SupportCreate_SupportCreate_tsx": 1,
"src_pages_SupportRequests_SupportRequests_tsx": 1,
"src_pages_Welcome_Welcome_tsx": 1,

};
	if (installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId])
	else if (installedCssChunks[chunkId] !== 0 && cssChunks[chunkId])
		promises.push(
			installedCssChunks[chunkId] = loadStylesheet(chunkId, fetchPriority).then(
				function () {
					installedCssChunks[chunkId] = 0;
				},
				function (e) {
					delete installedCssChunks[chunkId];
					throw e;
				}
			)
		)
}

var oldTags = [];
var newTags = [];
var applyHandler = function (options) {
	return {
		dispose: function () {
			for (var i = 0; i < oldTags.length; i++) {
				var oldTag = oldTags[i];
				if (oldTag.parentNode) oldTag.parentNode.removeChild(oldTag);
			}
			oldTags.length = 0;
		},
		apply: function () {
			for (var i = 0; i < newTags.length; i++) newTags[i].rel = "stylesheet";
			newTags.length = 0;
		}
	}
}
__webpack_require__.hmrC.miniCss = function (chunkIds, removedChunks, removedModules, promises, applyHandlers, updatedModulesList) {
	applyHandlers.push(applyHandler);
	chunkIds.forEach(function (chunkId) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		var oldTag = findStylesheet(href, fullhref);
		if (!oldTag) return;
		promises.push(new Promise(function (resolve, reject) {
			var tag = createStylesheet(
				chunkId,

				/**
					If dynamically add link tag through dom API and there is already a loaded style link, browsers sometimes treats the new link tag as the same link, and won't fetch the new style.
					Use query to avoid browser cache the link tag, force to re-fetch new style, this is the same strategy as updateCss API, this can happen during lazy compilation
				 */
				`${fullhref}?${Date.now()}`,
				oldTag,
				function () {
					tag.as = "style";
					tag.rel = "preload";
					resolve();
				},
				reject
			);
			oldTags.push(oldTag);
			newTags.push(tag);
		}))
	});
}

// no prefetch
// no preload